import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Icon from "../../controls/Icons/Icon";
import { Row, Col, Form, Spinner, Card, Button, Table, Modal, CloseButton } from "react-bootstrap";
import ErrorHandler from "../../controls/ErrorHandler";
import { ErrorBoundary } from 'react-error-boundary';
import { dateDisplayFormater } from "../../../Utils";
import useFetchWithCancellation from '../../../customhooks/useFetchWithCancellation';
import { useNavigate } from 'react-router-dom';
import InvoiceReport from "./InvoiceReport";
import "./InvoiceForApproval.css";

export default function InvoiceEditApproval() {
    const state = useSelector(state => state);
    const formRef = useRef();
    const { fetchData } = useFetchWithCancellation();
    const [validated, setValidated] = useState(false);
    const [data, setData] = useState({
        fkInvoiceId: 0,
        User: "",
        UserId: 0,
        CreatedDate: new Date(),
        InvoiceNumber: "",
        isExceedingAmt: false,
        IFAvailableAmt: 0,
        IFSpentAmt: 0,
        InvoiceAmt: 0,
        InvoicetypeId:0

    });
    const [pdfdata, setpdfdata] = useState();
    const navigate = useNavigate();
    const [ShowInvReport, setShowInvReport] = useState(false);
    const [invoiceNumber, setinvoiceNumber] = useState();
    const dispatch = useDispatch();
    const [isExceedIFAvailAmt, setisExceedIFAvailAmt] = useState(false);

    useEffect(() => {
        if (state.invIDEditApproval) {
           // console.log("state values");
           console.log(state.invIDEditApproval);
            var loggedInUser = JSON.parse(localStorage.getItem("user"));
            setData(state.invIDEditApproval);
            setData(dat => ({ ...dat, User: loggedInUser.name, UserId: loggedInUser.Id, CreatedDate:new Date() }));
            // setData(dat => ({ ...dat, fkInvoiceId: state.invIDEditApproval, UserId: loggedInUser.Id }));
            if (state.invIDEditApproval.InvoicetypeId != 7) {
                if (state.invIDEditApproval.IFAvailableAmt < (parseFloat(state.invIDEditApproval.IFSpentAmt) + parseFloat(state.invIDEditApproval.InvoiceAmt))) {
                    setisExceedIFAvailAmt(true);
                    // exceedingIFAvailAmt = true;
                }
            }
        }
    }, []);
    useEffect(() => {
        if (data.fkInvoiceId > 0) {
            fetch(state.projectdetail.API + "/invoicePDF/Get?id=" + data.fkInvoiceId, {
                method: "Get"
            }).then(response => response.json()).then((res) => {
                if (res) {
                    setpdfdata(res);
                }
                else {
                    window.alert('Something went wrong', function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
                }

            }).catch((err) => {
                if (err && err.name === 'AbortError') return;
                window.HandleError("InvoiceEditApproval.js ==> Invoice Get", null, null, err);
                console.log(err)
            }).finally(() => {
                //setLoading(false);
            });
        }
    }, [data.fkInvoiceId])

    const handleChange = (e) => {
        let value = e.target.value;
        let name = e.target.name;
        if (e.target.value) {
            setData(d => ({ ...d, [name]: value }));
        }
    }
    const handleViewInvoice = () => {
        console.log("Invoice Number : " + data.InvoiceNumber);
        //navigate("/admin/invoiceforapproval/InvoiceReport");
        // navigate("/admin/invoiceforapproval/InvoiceReport");
        setinvoiceNumber(data.InvoiceNumber);
        setShowInvReport(true);
    }

    const CloseInvReport = () => {
        setShowInvReport(false);
    }
    const SaveData = (e,status) => {
       // console.log("Save Data");
       // console.log(data);
       // alert("status : " + status);
        if (data && data.fkInvoiceId > 0) {

            let obj = new Object();
            obj.fkInvoiceId = data.fkInvoiceId;
            obj.UserNotes = data.Notes;
            obj.CreatedBy = data.UserId;
            obj.ModifiedBy = data.UserId;
           // obj.status = status;
            // obj.isActive = 1;

            fetchData(state.projectdetail.API + "/invoiceNotes/Save?Status=" + status, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(obj)
            }).then(response => response.json()).then((res) => {
                if (res) {
                    fetch(state.projectdetail.API + "/invoice/GetInvoiceCountByStatus?status=Sent for Approval", {
                        method: "Get"
                    }).then(response => response.json()).then((res) => {
                        if (res > 0) {
                           
                            dispatch({ type: "ADDINVCNTFORACTION", payload: res });
                        }
                        else {
                           
                            dispatch({ type: "ADDINVCNTFORACTION", payload: 0 });
                            // window.alert('Something went wrong', function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
                        }

                    }).catch((err) => {
                        if (err && err.name === 'AbortError') return;
                        window.HandleError("Invoice.js ==> Invoice Get", null, null, err);
                        console.log(err)
                    }).finally(() => {
                        //setLoading(false);
                    });
                    navigate("/admin/invoice");
                }
                else {
                    window.alert(res.Message, function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
                }
            }).catch((err) => {
                if (err && err.name === 'AbortError') return;
                window.HandleError("PCPInvoiceNotes.js ==> Invoice notes save", null, null, err);
                window.alert(state.projectdetail.ErrorMessage);
            }).finally(() => {
                // setLoading(false);
                // dispatch({ type: UpdtInvoiceContAction.ClearInvoiceContent });
            });

        }
    }
    return (<ErrorBoundary FallbackComponent={ErrorHandler}>
        <Form noValidate validated={validated} ref={formRef}>
            <div>

                {/*<div>*/}
                {/*    Invoice Notes Screen : {state.invIDNote}*/}
                {/*</div>*/}
                <Row>
                    <Col>
                        <Card className="border">
                            <Card.Body>
                                <Row md={12}>
                                    <Col md={6}>
                                        <div><Form.Group>
                                            <Form.Label>User:</Form.Label>
                                            <Form.Control type="text" name="User" value={data.User} disabled autoComplete="off" />
                                        </Form.Group></div>
                                    </Col>
                                    <Col md={3}></Col>
                                    <Col md={3}>
                                        <div><Form.Group>
                                            <Form.Label>Date:</Form.Label>
                                            <Form.Control type="text" name="CreatedDate" value={dateDisplayFormater(data.CreatedDate)} disabled autoComplete="off" />
                                        </Form.Group></div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6}>
                                        <div><Form.Group>
                                            <Form.Label>Invoice Number:</Form.Label>
                                            <Form.Control type="text" name="InvoiceNumber" value={data.InvoiceNumber} disabled autoComplete="off" />
                                        </Form.Group></div>
                                    </Col>
                                    <Col md={6}> {isExceedIFAvailAmt} {isExceedIFAvailAmt &&

                                        <span style={{color:'red'}}>You are approving an Invoice which is more than the approved amount.If you do not wish to approve return or reject.</span>
                                        }</Col>
                                    {/*<Col md={3}>*/}
                                    {/*    */}{/*<Button*/}
                                    {/*    */}{/*    className="btn-xs me-2 mb-2 p-0" variant="link"*/}
                                    {/*    */}{/*    onClick={handleViewInvoice}*/}
                                    {/*    */}{/*>Click Here to View Invoice</Button> */}
                                               
                                    {/*</Col>*/}
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <Form.Group>
                                            <Form.Label>Notes<code className='required-symbol'></code></Form.Label>
                                            <Form.Control as="textarea" rows={5} name="Notes" onChange={(e) => { handleChange(e) }}
                                                value={data.Notes} autoComplete="off" placeholder="Enter notes here..." />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <p></p>
                                </Row>
                                <Row>
                                    <Col md={4}>
                                        <Button
                                            className="btn-xs me-2 mb-2 p-0" variant="link"
                                            onClick={handleViewInvoice}
                                        >Click Here to View Invoice</Button>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={3}></Col>
                                    <Col md={2}>
                                        <Button variant="success"
                                            style={{ align: 'right', height: '60px', width: '120px' }}
                                            onClick={(e) => { SaveData(e,"Approved") }}>
                                            Approve
                                        </Button>
                                    </Col>
                                    <Col md={2}>
                                        <Button variant="warning"
                                            style={{ align: 'right', height: '60px', width:'120px'}}
                                            onClick={(e) => { SaveData(e, "Returned") }}>
                                            Return
                                        </Button>
                                    </Col>
                                    <Col md={2}>
                                        <Button variant="danger"
                                            style={{ align: 'right', height: '60px', width: '120px' }}
                                            onClick={(e) => { SaveData(e, "Rejected") }}>
                                            Reject 
                                        </Button>
                                    </Col>
                                    <Col md={3}>
                                        
                                        <Button variant="primary" disabled
                                            style={{ align: 'right', height: '60px', width: '150px' }}
                                            onClick={(e) => { SaveData(e, "Sent for Parent Approval") }}>
                                            Sent for Parent Approval
                                        </Button>
                                    </Col>

                                </Row>

                                {/*<Modal show={ShowInvReport} onHide={CloseInvReport}*/}
                                {/*    size="xl" backdrop="static" keyboard={false} style={{ overflow: "hidden" }}*/}
                                {/*    dialogClassName="custom-modal-position" scrollable >*/}
                                {/*    <Modal.Header style={{ background: "#0a4081", color: "white" }}>*/}
                                {/*        <h4> Search Goal from clients  </h4>*/}
                                {/*        <CloseButton onClick={handleClose} className="btn-close" />*/}
                                {/*    </Modal.Header>*/}

                                <Modal size="lg" show={ShowInvReport} onHide={CloseInvReport} backdrop="static">
                                    <Modal.Header style={{ background: "#0a4081", color: "white" }} dialogClassName="custom-modal-position">
                                        <h4>Invoice :  {invoiceNumber}</h4>
                                        <CloseButton onClick={CloseInvReport} className="btn-close" />
                                    </Modal.Header>
                                    <Modal.Body>
                                        <InvoiceReport _inputValue={data.fkInvoiceId} _invNumber={invoiceNumber} onCancel={CloseInvReport} />
                                    </Modal.Body>
                                </Modal>

                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
        </Form>
    </ErrorBoundary>
    )

}